import { useEffect, useState } from "react";
import { client, fmt } from "@/lib/api";

function useBank() {
  const [bank, setBank] = useState(null);
  useEffect(() => { let active = true;
    client.get("/bank-transfer").then(r => { if (active) setBank(r.data); })
      .catch(() => { if (active) setBank({ enabled: false }); });
    return () => { active = false; };
  }, []);
  return bank;
}

export default function PaymentChoice({ value, onChange }) {
  const bank = useBank();
  return <fieldset style={{margin:"16px 0",padding:16,border:"1px solid #dfe4e8"}} data-testid="payment-method-choice">
    <legend>Ödeme yöntemi</legend>
    <label className="check"><input type="radio" name="payment_method" value="card" checked={value === "card"} onChange={onChange} data-testid="choose-card"/>
      <span>Kredi kartı · tek çekim veya taksit <small>PayTR ekranında taksit seçebilirsiniz. Vade farkı müşteri toplamına eklenir.</small></span></label>
    <label className="check"><input type="radio" name="payment_method" value="bank_transfer" checked={value === "bank_transfer"} disabled={!bank?.enabled} onChange={onChange} data-testid="choose-bank-transfer"/>
      <span>Havale / EFT <small>{bank?.enabled ? "Şirket banka hesabına ödeme. Hesap bilgileri siparişten sonra gösterilir." : bank ? "Şu anda kullanıma kapalı." : "Kullanılabilirlik kontrol ediliyor…"}</small></span></label>
  </fieldset>;
}

export function BankInstructions({ orderNo, total, firstName = "", lastName = "" }) {
  const bank = useBank();
  const reference = [orderNo, [firstName, lastName].map(x => x.trim()).filter(Boolean).join(" ")].filter(Boolean).join(" – ");
  if (!bank) return <p>Havale bilgileri yükleniyor…</p>;
  if (!bank.enabled) return <p className="notice">Havale bilgileri şu anda gösterilemiyor. Ödeme göndermeden önce sipariş numaranızla bizimle iletişime geçin.</p>;
  return <div className="legal-block" data-testid="order-bank-instructions">
    <h2>Havale / EFT bilgileri</h2>
    <p><b>Banka:</b> {bank.bank_name}<br/><b>Hesap sahibi:</b> {bank.account_holder}</p>
    <p><b>IBAN:</b> <strong style={{overflowWrap:"anywhere"}}>{bank.iban}</strong></p>
    <p><b>Gönderilecek tutar:</b> {fmt(total)}<br/><b>Açıklama:</b> <strong data-testid="bank-payment-reference">{reference}</strong></p>
    <p>Ödemeniz, tutarın şirket hesabına geçtiği kontrol edildikten sonra onaylanır. Sipariş takibinden durumunu görebilirsiniz.</p>
  </div>;
}
